var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _circle, _circle2, _circle3, _circle4, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _circle5, _circle6, _circle7, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _g, _g2, _path199, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 194,
    viewBox: "0 0 382 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10512_1257)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 382,
    height: 194,
    rx: 24,
    fill: "#601F93"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.613 139.627C116.736 143.733 117.31 196.882 111 227.046V255.682L475.807 270L482.116 63.2459C494.162 0.245981 379.824 -34.0113 336.423 6.54598C291.683 48.355 299.139 134.472 197.613 139.627Z",
    fill: "#6A48B3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M276.474 167.879H257.648V189.533H276.474V167.879Z",
    fill: "#463332"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M276.474 172.428H257.648V179.21H276.474V172.428Z",
    fill: "#463332"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 66.207H201.42C197.493 66.207 194.31 69.3844 194.31 73.3038V165.149C194.31 169.068 197.493 172.246 201.42 172.246H332.702C336.628 172.246 339.811 169.068 339.811 165.149V73.3038C339.811 69.3844 336.628 66.207 332.702 66.207Z",
    fill: "url(#paint0_linear_10512_1257)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M194.31 159.426V165.431C194.31 169.533 197.492 172.875 201.42 172.875H332.702C336.629 172.875 339.811 169.55 339.811 165.431V159.426H194.31Z",
    fill: "url(#paint1_linear_10512_1257)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M330.034 68.375H204.104C200.343 68.375 197.293 71.419 197.293 75.174V148.657C197.293 152.412 200.343 155.456 204.104 155.456H330.034C333.795 155.456 336.845 152.412 336.845 148.657V75.174C336.845 71.419 333.795 68.375 330.034 68.375Z",
    fill: "url(#paint2_linear_10512_1257)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M331.127 72.2954C329.934 71.0382 328.244 70.2441 326.371 70.2441H205.679C202.066 70.2441 199.149 73.1557 199.149 76.762V147.201C199.149 148.69 199.647 150.079 200.508 151.171L331.127 72.2954Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M244.622 186.422H289.499C291.355 186.422 292.863 187.927 292.863 189.78V194.511H241.242V189.78C241.242 187.927 242.75 186.422 244.606 186.422H244.622Z",
    fill: "url(#paint3_linear_10512_1257)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M289.499 186.422H267.243C269.099 186.422 270.607 187.927 270.607 189.78V194.511H292.863V189.78C292.863 187.927 291.355 186.422 289.499 186.422Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M257.764 188.639C257.764 189.747 251.665 189.979 247.307 189.979C243.446 189.979 242.833 189.383 242.833 188.639C242.833 187.894 243.711 187.299 247.307 187.299C251.665 187.299 257.764 187.547 257.764 188.639Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M262.437 188.638C262.437 189.085 261.575 189.399 260.631 189.399C259.686 189.399 259.023 189.051 259.023 188.638C259.023 188.224 259.686 187.877 260.631 187.877C261.575 187.877 262.437 188.191 262.437 188.638Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M292.88 193.021H241.258V194.51H292.88V193.021Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M339.811 159.426H194.31V161.361H339.811V159.426Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M331.393 166.456C331.393 167.978 330.15 169.219 328.625 169.219C327.1 169.219 325.858 167.978 325.858 166.456C325.858 164.934 327.1 163.693 328.625 163.693C330.15 163.693 331.393 164.934 331.393 166.456Z",
    fill: "#463332"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M330.465 166.456C330.465 167.466 329.653 168.276 328.642 168.276C327.631 168.276 326.819 167.466 326.819 166.456C326.819 165.447 327.631 164.637 328.642 164.637C329.653 164.637 330.465 165.447 330.465 166.456Z",
    fill: "url(#paint4_linear_10512_1257)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M330.654 74.9609H273V151.967H330.654V74.9609Z",
    fill: "#6D4791"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M330.654 72H273V149.006H330.654V72Z",
    fill: "#FFF4EE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M326.792 75.4082H276.828V82.8359H326.792V75.4082Z",
    fill: "url(#paint5_linear_10512_1257)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M287 81.5091V77.076H287.532V81.0847H289.597V81.5091H287Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M290.327 81.5091V77.076H293.069V77.513H290.859V79.0582H292.879V79.4888H290.859V81.0721H293.069V81.5091H290.327Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M295.314 81.5851C294.989 81.5851 294.706 81.5259 294.466 81.4077C294.225 81.2895 294.039 81.1249 293.908 80.9138C293.777 80.7027 293.712 80.4578 293.712 80.1791H294.269C294.269 80.3522 294.309 80.5127 294.39 80.6604C294.47 80.804 294.586 80.9201 294.738 81.0088C294.894 81.0932 295.086 81.1354 295.314 81.1354C295.614 81.1354 295.846 81.0636 296.011 80.9201C296.175 80.7765 296.258 80.5971 296.258 80.3818C296.258 80.2045 296.22 80.063 296.144 79.9575C296.068 79.8477 295.964 79.7591 295.833 79.6915C295.707 79.624 295.559 79.5648 295.39 79.5142C295.226 79.4635 295.052 79.4065 294.871 79.3432C294.529 79.225 294.276 79.0793 294.111 78.9062C293.946 78.7289 293.864 78.4988 293.864 78.2159C293.86 77.9795 293.915 77.7705 294.029 77.589C294.143 77.4032 294.303 77.2597 294.51 77.1583C294.721 77.0528 294.97 77 295.257 77C295.54 77 295.785 77.0528 295.992 77.1583C296.203 77.2639 296.365 77.4095 296.479 77.5953C296.598 77.7811 296.659 77.9922 296.663 78.2286H296.106C296.106 78.1062 296.074 77.9858 296.011 77.8676C295.947 77.7452 295.85 77.646 295.719 77.57C295.593 77.494 295.432 77.456 295.238 77.456C294.998 77.4518 294.799 77.513 294.643 77.6396C294.491 77.7663 294.415 77.9415 294.415 78.1653C294.415 78.3553 294.468 78.5009 294.573 78.6022C294.683 78.7036 294.835 78.788 295.029 78.8556C295.223 78.9189 295.447 78.9928 295.7 79.0772C295.912 79.1532 296.102 79.2419 296.27 79.3432C296.439 79.4445 296.57 79.5754 296.663 79.7358C296.76 79.8963 296.809 80.101 296.809 80.3501C296.809 80.5612 296.754 80.7618 296.644 80.9518C296.534 81.1375 296.368 81.2895 296.144 81.4077C295.924 81.5259 295.648 81.5851 295.314 81.5851Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M298.975 81.5851C298.65 81.5851 298.367 81.5259 298.127 81.4077C297.886 81.2895 297.7 81.1249 297.569 80.9138C297.439 80.7027 297.373 80.4578 297.373 80.1791H297.93C297.93 80.3522 297.971 80.5127 298.051 80.6604C298.131 80.804 298.247 80.9201 298.399 81.0088C298.555 81.0932 298.747 81.1354 298.975 81.1354C299.275 81.1354 299.507 81.0636 299.672 80.9201C299.837 80.7765 299.919 80.5971 299.919 80.3818C299.919 80.2045 299.881 80.063 299.805 79.9575C299.729 79.8477 299.626 79.7591 299.495 79.6915C299.368 79.624 299.22 79.5648 299.051 79.5142C298.887 79.4635 298.714 79.4065 298.532 79.3432C298.19 79.225 297.937 79.0793 297.772 78.9062C297.607 78.7289 297.525 78.4988 297.525 78.2159C297.521 77.9795 297.576 77.7705 297.69 77.589C297.804 77.4032 297.964 77.2597 298.171 77.1583C298.382 77.0528 298.631 77 298.918 77C299.201 77 299.446 77.0528 299.653 77.1583C299.864 77.2639 300.027 77.4095 300.141 77.5953C300.259 77.7811 300.32 77.9922 300.324 78.2286H299.767C299.767 78.1062 299.735 77.9858 299.672 77.8676C299.609 77.7452 299.512 77.646 299.381 77.57C299.254 77.494 299.094 77.456 298.899 77.456C298.659 77.4518 298.46 77.513 298.304 77.6396C298.152 77.7663 298.076 77.9415 298.076 78.1653C298.076 78.3553 298.129 78.5009 298.234 78.6022C298.344 78.7036 298.496 78.788 298.69 78.8556C298.885 78.9189 299.108 78.9928 299.362 79.0772C299.573 79.1532 299.763 79.2419 299.932 79.3432C300.101 79.4445 300.231 79.5754 300.324 79.7358C300.421 79.8963 300.47 80.101 300.47 80.3501C300.47 80.5612 300.415 80.7618 300.305 80.9518C300.196 81.1375 300.029 81.2895 299.805 81.4077C299.585 81.5259 299.309 81.5851 298.975 81.5851Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M303.238 81.5851C302.803 81.5851 302.421 81.4901 302.092 81.3001C301.767 81.1059 301.511 80.8357 301.326 80.4895C301.144 80.1433 301.053 79.7443 301.053 79.2925C301.053 78.8408 301.144 78.4439 301.326 78.1019C301.511 77.7557 301.767 77.4855 302.092 77.2913C302.421 77.0971 302.803 77 303.238 77C303.677 77 304.059 77.0971 304.385 77.2913C304.714 77.4855 304.969 77.7557 305.151 78.1019C305.332 78.4439 305.423 78.8408 305.423 79.2925C305.423 79.7443 305.332 80.1433 305.151 80.4895C304.969 80.8357 304.714 81.1059 304.385 81.3001C304.059 81.4901 303.677 81.5851 303.238 81.5851ZM303.238 81.1164C303.563 81.1164 303.848 81.0446 304.093 80.9011C304.342 80.7533 304.534 80.5443 304.67 80.2741C304.809 79.9997 304.878 79.6725 304.878 79.2925C304.878 78.9125 304.809 78.5875 304.67 78.3173C304.534 78.047 304.342 77.8402 304.093 77.6966C303.848 77.5489 303.563 77.475 303.238 77.475C302.913 77.475 302.626 77.5489 302.377 77.6966C302.132 77.8402 301.94 78.047 301.801 78.3173C301.666 78.5875 301.598 78.9125 301.598 79.2925C301.598 79.6725 301.666 79.9997 301.801 80.2741C301.94 80.5443 302.132 80.7533 302.377 80.9011C302.626 81.0446 302.913 81.1164 303.238 81.1164Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M306.191 81.5091V77.076H306.723L309.085 80.6288V77.076H309.617V81.5091H309.085L306.723 77.9563V81.5091H306.191Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M312.67 81.5091V77.6713L311.954 77.8296V77.4623L312.847 77.076H313.208V81.5091H312.67Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M314.074 81.5091V81.1354C314.374 80.899 314.657 80.6604 314.923 80.4198C315.193 80.1749 315.432 79.9343 315.638 79.6978C315.85 79.4614 316.014 79.2292 316.132 79.0012C316.255 78.7732 316.316 78.5537 316.316 78.3426C316.316 78.1864 316.289 78.0407 316.234 77.9056C316.183 77.7705 316.099 77.6628 315.98 77.5826C315.862 77.4982 315.702 77.456 315.499 77.456C315.305 77.456 315.142 77.5003 315.011 77.589C314.881 77.6734 314.781 77.7874 314.714 77.9309C314.65 78.0745 314.619 78.2286 314.619 78.3932H314.106C314.106 78.1019 314.167 77.8528 314.29 77.646C314.412 77.4349 314.579 77.2744 314.79 77.1647C315.001 77.0549 315.239 77 315.505 77C315.898 77 316.219 77.1119 316.468 77.3356C316.721 77.5552 316.848 77.8845 316.848 78.3236C316.848 78.5853 316.783 78.845 316.652 79.1025C316.521 79.3559 316.354 79.6028 316.151 79.8435C315.949 80.0799 315.731 80.3016 315.499 80.5085C315.271 80.7153 315.058 80.9011 314.859 81.0658H317V81.5091H314.074Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M298.747 88.1298L298.734 87H287L287.013 88.1298H298.747Z",
    fill: "#DDC8BA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M326 88.1298L325.974 87H300.113L300.139 88.1298H326Z",
    fill: "#DDC8BA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M298.747 93.4403L298.734 92.3105H287L287.013 93.4403H298.747Z",
    fill: "#DDC8BA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M326 93.4403L325.974 92.3105H300.113L300.139 93.4403H326Z",
    fill: "#DDC8BA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M326 90.7782V89.6484H312.536L312.562 90.7782H326Z",
    fill: "#DDC8BA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M311.378 90.7782V89.6484H287L287.026 90.7782H311.378Z",
    fill: "#DDC8BA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M293.713 96.1161L293.699 94.9863H287L287.013 96.1161H293.713Z",
    fill: "#DDC8BA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M310.78 96.0634L310.754 94.9336H295.091L295.104 96.0634H310.78Z",
    fill: "#DDC8BA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M298.747 101.13L298.734 100H287L287.013 101.13H298.747Z",
    fill: "#DDC8BA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M326 101.13L325.974 100H300.113L300.139 101.13H326Z",
    fill: "#DDC8BA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M298.747 106.44L298.734 105.311H287L287.013 106.44H298.747Z",
    fill: "#DDC8BA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M326 106.44L325.974 105.311H300.113L300.139 106.44H326Z",
    fill: "#DDC8BA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M326 103.778V102.648H312.536L312.562 103.778H326Z",
    fill: "#DDC8BA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M311.378 103.778V102.648H287L287.026 103.778H311.378Z",
    fill: "#DDC8BA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M293.713 109.116L293.699 107.986H287L287.013 109.116H293.713Z",
    fill: "#DDC8BA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M310.78 109.063L310.754 107.934H295.091L295.104 109.063H310.78Z",
    fill: "#DDC8BA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M298.747 114.13L298.734 113H287L287.013 114.13H298.747Z",
    fill: "#DDC8BA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M326 114.13L325.974 113H300.113L300.139 114.13H326Z",
    fill: "#DDC8BA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M298.747 119.44L298.734 118.311H287L287.013 119.44H298.747Z",
    fill: "#DDC8BA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M326 119.44L325.974 118.311H300.113L300.139 119.44H326Z",
    fill: "#DDC8BA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M326 116.778V115.648H312.536L312.562 116.778H326Z",
    fill: "#DDC8BA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M311.378 116.778V115.648H287L287.026 116.778H311.378Z",
    fill: "#DDC8BA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M293.713 122.116L293.699 120.986H287L287.013 122.116H293.713Z",
    fill: "#DDC8BA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M310.78 122.063L310.754 120.934H295.091L295.104 122.063H310.78Z",
    fill: "#DDC8BA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M298.747 127.13L298.734 126H287L287.013 127.13H298.747Z",
    fill: "#DDC8BA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M326 127.13L325.974 126H300.113L300.139 127.13H326Z",
    fill: "#DDC8BA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M298.747 132.44L298.734 131.311H287L287.013 132.44H298.747Z",
    fill: "#DDC8BA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M326 132.44L325.974 131.311H300.113L300.139 132.44H326Z",
    fill: "#DDC8BA"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M326 129.778V128.648H312.536L312.562 129.778H326Z",
    fill: "#DDC8BA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M311.378 129.778V128.648H287L287.026 129.778H311.378Z",
    fill: "#DDC8BA"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M293.713 135.116L293.699 133.986H287L287.013 135.116H293.713Z",
    fill: "#DDC8BA"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M310.78 135.063L310.754 133.934H295.091L295.104 135.063H310.78Z",
    fill: "#DDC8BA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M298.747 138.13L298.734 137H287L287.013 138.13H298.747Z",
    fill: "#DDC8BA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M326 138.13L325.974 137H300.113L300.139 138.13H326Z",
    fill: "#DDC8BA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M298.747 143.44L298.734 142.311H287L287.013 143.44H298.747Z",
    fill: "#DDC8BA"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M326 143.44L325.974 142.311H300.113L300.139 143.44H326Z",
    fill: "#DDC8BA"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M326 140.778V139.648H312.536L312.562 140.778H326Z",
    fill: "#DDC8BA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M311.378 140.778V139.648H287L287.026 140.778H311.378Z",
    fill: "#DDC8BA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 90,
    r: 3,
    fill: "url(#paint6_linear_10512_1257)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 103,
    r: 3,
    fill: "url(#paint7_linear_10512_1257)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 116,
    r: 3,
    fill: "url(#paint8_linear_10512_1257)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 129,
    r: 3,
    fill: "url(#paint9_linear_10512_1257)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M265.653 75.3555H208V152.362H265.653V75.3555Z",
    fill: "#6D4791"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M265.653 72.3945H208V149.401H265.653V72.3945Z",
    fill: "#FFF4EE"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M233.747 88.1317L233.734 87.002H222L222.013 88.1317H233.747Z",
    fill: "#DDC8BA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M261 88.1317L260.974 87.002H235.113L235.139 88.1317H261Z",
    fill: "#DDC8BA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M233.747 93.4423L233.734 92.3125H222L222.013 93.4423H233.747Z",
    fill: "#DDC8BA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M261 93.4423L260.974 92.3125H235.113L235.139 93.4423H261Z",
    fill: "#DDC8BA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M261 90.7802V89.6504H247.536L247.562 90.7802H261Z",
    fill: "#DDC8BA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M246.378 90.7802V89.6504H222L222.026 90.7802H246.378Z",
    fill: "#DDC8BA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M228.712 96.118L228.699 94.9883H222L222.013 96.118H228.712Z",
    fill: "#DDC8BA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M245.78 96.0653L245.754 94.9355H230.091L230.104 96.0653H245.78Z",
    fill: "#DDC8BA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M233.747 101.132L233.734 100.002H222L222.013 101.132H233.747Z",
    fill: "#DDC8BA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M261 101.132L260.974 100.002H235.113L235.139 101.132H261Z",
    fill: "#DDC8BA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M233.747 106.442L233.734 105.312H222L222.013 106.442H233.747Z",
    fill: "#DDC8BA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M261 106.442L260.974 105.312H235.113L235.139 106.442H261Z",
    fill: "#DDC8BA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M261 103.78V102.65H247.536L247.562 103.78H261Z",
    fill: "#DDC8BA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M246.378 103.78V102.65H222L222.026 103.78H246.378Z",
    fill: "#DDC8BA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M228.712 109.118L228.699 107.988H222L222.013 109.118H228.712Z",
    fill: "#DDC8BA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M245.78 109.065L245.754 107.936H230.091L230.104 109.065H245.78Z",
    fill: "#DDC8BA"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M233.747 114.132L233.734 113.002H222L222.013 114.132H233.747Z",
    fill: "#DDC8BA"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M261 114.132L260.974 113.002H235.113L235.139 114.132H261Z",
    fill: "#DDC8BA"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M233.747 119.442L233.734 118.312H222L222.013 119.442H233.747Z",
    fill: "#DDC8BA"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M261 119.442L260.974 118.312H235.113L235.139 119.442H261Z",
    fill: "#DDC8BA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M261 116.78V115.65H247.536L247.562 116.78H261Z",
    fill: "#DDC8BA"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M246.378 116.78V115.65H222L222.026 116.78H246.378Z",
    fill: "#DDC8BA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M228.712 122.118L228.699 120.988H222L222.013 122.118H228.712Z",
    fill: "#DDC8BA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M245.78 122.065L245.754 120.936H230.091L230.104 122.065H245.78Z",
    fill: "#DDC8BA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M226.964 129.535L226.948 128.096H212L212.017 129.535H226.964Z",
    fill: "#DDC8BA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M261.682 129.535L261.649 128.096H228.704L228.738 129.535H261.682Z",
    fill: "#DDC8BA"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M261.682 126.441V125.002H244.531L244.564 126.441H261.682Z",
    fill: "#DDC8BA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M243.056 126.441V125.002H212L212.033 126.441H243.056Z",
    fill: "#DDC8BA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M220.551 132.662L220.534 131.223H212L212.017 132.662H220.551Z",
    fill: "#DDC8BA"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M242.293 132.595L242.26 131.156H222.308L222.324 132.595H242.293Z",
    fill: "#DDC8BA"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M261.792 75.8027H211.828V83.2304H261.792V75.8027Z",
    fill: "url(#paint10_linear_10512_1257)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M222 81.9191V77.0848H222.568V81.4564H224.77V81.9191H222Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M225.55 81.9191V77.0848H228.475V77.5613H226.117V79.2464H228.273V79.716H226.117V81.4426H228.475V81.9191H225.55Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M230.87 82.002C230.523 82.002 230.222 81.9375 229.965 81.8086C229.708 81.6797 229.51 81.5001 229.37 81.2699C229.231 81.0397 229.161 80.7727 229.161 80.4688H229.755C229.755 80.6576 229.798 80.8325 229.884 80.9937C229.969 81.1502 230.093 81.2768 230.255 81.3735C230.422 81.4656 230.627 81.5116 230.87 81.5116C231.19 81.5116 231.438 81.4334 231.614 81.2768C231.789 81.1203 231.877 80.9246 231.877 80.6898C231.877 80.4964 231.836 80.3422 231.755 80.2271C231.674 80.1074 231.564 80.0107 231.424 79.937C231.289 79.8634 231.132 79.7989 230.951 79.7437C230.776 79.6884 230.591 79.6263 230.397 79.5572C230.032 79.4283 229.762 79.2694 229.587 79.0807C229.411 78.8873 229.323 78.6364 229.323 78.3279C229.319 78.0701 229.377 77.8422 229.499 77.6442C229.62 77.4416 229.792 77.2851 230.012 77.1746C230.237 77.0595 230.503 77.002 230.809 77.002C231.111 77.002 231.373 77.0595 231.593 77.1746C231.818 77.2897 231.992 77.4485 232.114 77.6511C232.24 77.8537 232.305 78.0839 232.309 78.3417H231.715C231.715 78.2082 231.681 78.077 231.614 77.9481C231.546 77.8146 231.442 77.7064 231.303 77.6235C231.168 77.5406 230.996 77.4992 230.789 77.4992C230.532 77.4946 230.321 77.5613 230.154 77.6995C229.992 77.8376 229.911 78.0287 229.911 78.2727C229.911 78.4799 229.967 78.6387 230.08 78.7492C230.197 78.8597 230.359 78.9518 230.566 79.0254C230.773 79.0945 231.012 79.1751 231.282 79.2671C231.508 79.35 231.71 79.4467 231.891 79.5572C232.071 79.6677 232.21 79.8104 232.309 79.9854C232.413 80.1603 232.465 80.3836 232.465 80.6553C232.465 80.8855 232.406 81.1042 232.289 81.3113C232.172 81.5139 231.994 81.6797 231.755 81.8086C231.521 81.9375 231.226 82.002 230.87 82.002Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M234.776 82.002C234.43 82.002 234.128 81.9375 233.871 81.8086C233.614 81.6797 233.416 81.5001 233.276 81.2699C233.137 81.0397 233.067 80.7727 233.067 80.4688H233.662C233.662 80.6576 233.704 80.8325 233.79 80.9937C233.876 81.1502 233.999 81.2768 234.162 81.3735C234.328 81.4656 234.533 81.5116 234.776 81.5116C235.096 81.5116 235.344 81.4334 235.52 81.2768C235.695 81.1203 235.783 80.9246 235.783 80.6898C235.783 80.4964 235.743 80.3422 235.662 80.2271C235.58 80.1074 235.47 80.0107 235.33 79.937C235.195 79.8634 235.038 79.7989 234.858 79.7437C234.682 79.6884 234.497 79.6263 234.303 79.5572C233.939 79.4283 233.668 79.2694 233.493 79.0807C233.317 78.8873 233.229 78.6364 233.229 78.3279C233.225 78.0701 233.283 77.8422 233.405 77.6442C233.526 77.4416 233.698 77.2851 233.918 77.1746C234.144 77.0595 234.409 77.002 234.716 77.002C235.017 77.002 235.279 77.0595 235.499 77.1746C235.725 77.2897 235.898 77.4485 236.02 77.6511C236.146 77.8537 236.211 78.0839 236.216 78.3417H235.621C235.621 78.2082 235.587 78.077 235.52 77.9481C235.452 77.8146 235.348 77.7064 235.209 77.6235C235.074 77.5406 234.903 77.4992 234.695 77.4992C234.439 77.4946 234.227 77.5613 234.06 77.6995C233.898 77.8376 233.817 78.0287 233.817 78.2727C233.817 78.4799 233.873 78.6387 233.986 78.7492C234.103 78.8597 234.265 78.9518 234.472 79.0254C234.68 79.0945 234.918 79.1751 235.189 79.2671C235.414 79.35 235.616 79.4467 235.797 79.5572C235.977 79.6677 236.116 79.8104 236.216 79.9854C236.319 80.1603 236.371 80.3836 236.371 80.6553C236.371 80.8855 236.312 81.1042 236.195 81.3113C236.078 81.5139 235.9 81.6797 235.662 81.8086C235.427 81.9375 235.132 82.002 234.776 82.002Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M239.324 82.002C238.86 82.002 238.453 81.8984 238.102 81.6912C237.755 81.4794 237.482 81.1847 237.284 80.8072C237.09 80.4297 236.993 79.9946 236.993 79.502C236.993 79.0093 237.09 78.5765 237.284 78.2036C237.482 77.8261 237.755 77.5314 238.102 77.3196C238.453 77.1078 238.86 77.002 239.324 77.002C239.793 77.002 240.201 77.1078 240.547 77.3196C240.899 77.5314 241.171 77.8261 241.365 78.2036C241.559 78.5765 241.655 79.0093 241.655 79.502C241.655 79.9946 241.559 80.4297 241.365 80.8072C241.171 81.1847 240.899 81.4794 240.547 81.6912C240.201 81.8984 239.793 82.002 239.324 82.002ZM239.324 81.4909C239.671 81.4909 239.975 81.4126 240.237 81.2561C240.502 81.095 240.707 80.8671 240.851 80.5724C241 80.2731 241.074 79.9163 241.074 79.502C241.074 79.0876 241 78.7331 240.851 78.4384C240.707 78.1438 240.502 77.9182 240.237 77.7616C239.975 77.6005 239.671 77.5199 239.324 77.5199C238.978 77.5199 238.671 77.6005 238.406 77.7616C238.144 77.9182 237.939 78.1438 237.791 78.4384C237.647 78.7331 237.574 79.0876 237.574 79.502C237.574 79.9163 237.647 80.2731 237.791 80.5724C237.939 80.8671 238.144 81.095 238.406 81.2561C238.671 81.4126 238.978 81.4909 239.324 81.4909Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M242.474 81.9191V77.0848H243.042L245.562 80.9591V77.0848H246.13V81.9191H245.562L243.042 78.0448V81.9191H242.474Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M249.387 81.9191V77.734L248.623 77.9066V77.5061L249.576 77.0848H249.961V81.9191H249.387Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M251.426 81.9191V77.734L250.662 77.9066V77.5061L251.615 77.0848H252V81.9191H251.426Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M226.964 137.441L226.948 136.002H212L212.017 137.441H226.964Z",
    fill: "#DDC8BA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M261.682 137.441L261.649 136.002H228.704L228.738 137.441H261.682Z",
    fill: "#DDC8BA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M226.964 144.207L226.948 142.768H212L212.017 144.207H226.964Z",
    fill: "#DDC8BA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M261.682 144.207L261.649 142.768H228.704L228.738 144.207H261.682Z",
    fill: "#DDC8BA"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M261.682 140.816V139.377H244.531L244.564 140.816H261.682Z",
    fill: "#DDC8BA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M243.056 140.816V139.377H212L212.033 140.816H243.056Z",
    fill: "#DDC8BA"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 90,
    r: 3,
    fill: "url(#paint11_linear_10512_1257)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 103,
    r: 3,
    fill: "url(#paint12_linear_10512_1257)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 116,
    r: 3,
    fill: "url(#paint13_linear_10512_1257)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M295.531 193.651C297.652 193.651 299.608 191.384 299.906 188.588C300.204 185.793 298.614 183.543 295.713 183.543C293.592 183.543 292.565 185.809 292.25 188.605C291.952 191.401 293.41 193.651 295.531 193.651ZM293.907 188.77C294.073 187.232 294.636 185.975 295.813 185.975C297.404 185.975 298.282 187.215 298.116 188.754C297.951 190.292 296.873 191.55 295.713 191.55C294.553 191.55 293.741 190.309 293.907 188.77Z",
    fill: "url(#paint14_linear_10512_1257)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M295.531 193.651C297.652 193.651 299.608 191.384 299.906 188.588C300.204 185.793 298.614 183.543 295.713 183.543C293.592 183.543 292.565 185.809 292.25 188.605C291.952 191.401 293.41 193.651 295.531 193.651ZM293.907 188.77C294.073 187.232 294.636 185.975 295.813 185.975C297.404 185.975 298.282 187.215 298.116 188.754C297.951 190.292 296.873 191.55 295.713 191.55C294.553 191.55 293.741 190.309 293.907 188.77Z",
    fill: "#398191"
  }))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M278.946 199.635L293.861 199.59C294.318 199.589 294.688 199.218 294.687 198.761L294.627 178.463C294.625 178.006 294.253 177.637 293.796 177.638L278.881 177.682C278.423 177.684 278.054 178.055 278.055 178.512L278.115 198.81C278.117 199.267 278.489 199.636 278.946 199.635Z",
    fill: "url(#paint15_linear_10512_1257)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M289.584 177.67L293.876 177.683C294.324 177.684 294.687 178.049 294.686 178.496L294.626 198.826C294.624 199.273 294.259 199.636 293.811 199.635L289.519 199.622L289.584 177.67Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M279.456 178.747C279.456 178.747 282.39 182.204 282.373 188.97C282.357 195.753 279.473 197.953 279.473 197.953V178.73L279.456 178.747Z",
    fill: "#FFF7E6"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M287.162 176.613C287.925 171.402 277.716 173.9 277.716 169.566C277.716 165.231 292.499 165.231 292.499 162.618C292.499 160.004 283.798 161.212 283.798 157.953C283.798 154.694 294.007 153.403 290.858 150.145C290.858 150.145 293.46 151.551 292.598 153.073C291.736 154.595 288.472 156.431 288.472 157.837C288.472 159.243 297.603 159.789 297.603 162.932C297.603 166.075 283.666 167.696 283.666 169.549C283.666 172.047 290.543 171.071 287.179 176.596L287.162 176.613Z",
    fill: "url(#paint16_linear_10512_1257)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10512_1257",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 301,
    y: 91,
    width: 99,
    height: 109
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M400 91.9961H301.464V199.639H400V91.9961Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10512_1257)"
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M366.889 120.946C366.889 125.363 369.143 128.953 371.911 128.953C374.678 128.953 376.932 125.363 376.932 120.946C376.932 116.529 374.678 112.939 371.911 112.939C369.143 112.939 366.889 116.529 366.889 120.946Z",
    fill: "url(#paint17_linear_10512_1257)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M366.889 120.946C366.889 125.363 369.143 128.953 371.911 128.953C374.678 128.953 376.932 125.363 376.932 120.946C376.932 116.529 374.678 112.939 371.911 112.939C369.143 112.939 366.889 116.529 366.889 120.946Z",
    fill: "#A69B9B"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M363.741 120.946C363.741 126.389 366.508 130.789 369.922 130.789C373.336 130.789 376.103 126.389 376.103 120.946C376.103 115.504 373.336 111.104 369.922 111.104C366.508 111.104 363.741 115.504 363.741 120.946Z",
    fill: "url(#paint18_linear_10512_1257)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M363.741 120.946C363.741 126.389 366.508 130.789 369.922 130.789C373.336 130.789 376.103 126.389 376.103 120.946C376.103 115.504 373.336 111.104 369.922 111.104C366.508 111.104 363.741 115.504 363.741 120.946Z",
    fill: "#463332"
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M351.229 134.678H316.876V184.289H351.229V134.678Z",
    fill: "url(#paint19_linear_10512_1257)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M351.229 136.396H319.212V182.551H351.229V136.396Z",
    fill: "#FFF4EE"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M338.916 156.199H321.831V157.787H338.916V156.199Z",
    fill: "#DDC8BA"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M338.916 162.006H321.831V163.594H338.916V162.006Z",
    fill: "#DDC8BA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M330.962 159.127H321.831V160.715H330.962V159.127Z",
    fill: "#DDC8BA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M348.594 156.199H340.292V157.787H348.594V156.199Z",
    fill: "#DDC8BA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M348.594 159.127H332.337V160.715H348.594V159.127Z",
    fill: "#DDC8BA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M348.594 139.275H321.831V142.501H348.594V139.275Z",
    fill: "#DDC8BA"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M338.916 145.43H321.831V147.018H338.916V145.43Z",
    fill: "#DDC8BA"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M338.916 151.236H321.831V152.824H338.916V151.236Z",
    fill: "#DDC8BA"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M330.962 148.357H321.831V149.946H330.962V148.357Z",
    fill: "#DDC8BA"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M348.594 145.43H340.292V147.018H348.594V145.43Z",
    fill: "#DDC8BA"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M348.594 148.357H332.337V149.946H348.594V148.357Z",
    fill: "#DDC8BA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M308.689 161.063C310.711 156.53 314.738 151.6 315.732 151.087C316.047 150.922 316.445 150.773 316.843 150.641V155.058C316.843 155.058 316.826 156.067 316.859 156.348C317.058 157.589 318.566 156.794 320.372 156.249C322.03 155.752 323.488 155.885 323.587 156.629C323.654 157.142 322.278 157.655 320.803 158.3C319.312 158.945 317.771 160.864 316.163 161.476C314.556 162.088 313.611 162.287 313.611 162.287C313.611 162.287 312.434 165.827 312.169 166.257L307.015 164.173L308.689 161.046V161.063Z",
    fill: "url(#paint20_linear_10512_1257)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M307.297 163.66L307.115 164.239L312.169 166.29C312.434 165.877 313.611 162.32 313.611 162.32C313.611 162.32 314.572 162.122 316.163 161.509C317.771 160.897 319.312 158.978 320.803 158.333C322.295 157.688 323.654 157.175 323.587 156.662C323.587 156.58 323.504 156.547 323.455 156.48C322.858 157.175 320.803 157.539 319.925 158.019C318.897 158.581 318.218 159.657 316.793 160.699C315.931 161.327 314.042 161.41 312.965 161.675C311.888 161.923 310.148 162.701 308.093 162.138L307.264 163.677L307.297 163.66Z",
    fill: "#C3694D"
  }))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M304.099 195.222C298.017 188.555 306.402 162.468 306.402 162.468C306.402 162.468 310.595 161.31 313.429 166.934C313.429 166.934 315.02 184.238 312.236 189.234C309.451 194.23 304.099 195.206 304.099 195.206V195.222Z",
    fill: "url(#paint21_linear_10512_1257)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M362.912 147.217C367.155 145.629 374.894 156.398 383.378 168.044C395.178 184.239 400.58 193.801 395.327 198.152C389.493 202.982 381.009 191.766 371.496 180.484C361.984 169.185 352.19 151.204 362.912 147.217Z",
    fill: "url(#paint22_linear_10512_1257)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M346.904 97.3238C346.904 97.3238 343.689 95.256 339.662 98.3991C334.177 102.684 336.712 109.135 335.95 113.718L345.064 103.875L346.904 97.3238Z",
    fill: "url(#paint23_linear_10512_1257)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M360.774 125.711C359.88 129.416 359.565 132.543 359.266 136.894C358.852 143.015 362.084 146.025 362.084 146.025C358.14 147.051 350.848 147.663 346.606 145.562C346.606 145.562 349.936 144.57 348.677 136.166C347.815 130.409 360.758 125.711 360.758 125.711H360.774Z",
    fill: "url(#paint24_linear_10512_1257)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M342.893 100.847C342.496 105.81 349.953 108.407 353.615 110.922C359.25 114.759 358.753 121.228 358.753 121.228L362.349 120.616C362.349 120.616 371.347 123.461 373.601 122.816C375.142 105.545 370.966 97.4393 358.604 94.6105C347.832 92.1456 343.208 96.9595 342.893 100.847Z",
    fill: "url(#paint25_linear_10512_1257)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M377.545 210.956C374.645 199.359 374.695 193.321 374.397 183.379C374.131 174.893 375.441 167.994 372.143 154.694C369.64 144.586 360.062 145.231 351.61 144.983C348.196 144.884 344.02 145.877 341.203 147.746C334.889 151.931 330.614 164.917 332.221 170.608C333.878 176.464 337.69 176.828 337.673 185.563C337.673 192.874 334.077 200.004 331.359 210.525C330.879 214.496 362.233 219.458 377.529 210.939L377.545 210.956Z",
    fill: "url(#paint26_linear_10512_1257)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M345.396 145.843C345.396 145.843 348.031 149.316 356.118 149.168C361.702 149.068 364.917 146.372 364.917 146.372C364.917 146.372 356.88 142.335 345.396 145.843Z",
    fill: "url(#paint27_linear_10512_1257)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M341.402 184.206C341.236 176.348 337.126 168.49 337.126 168.49L332.768 172.163C334.591 176.613 337.69 177.671 337.673 185.562C337.673 192.874 334.077 200.004 331.359 210.525C331.293 211.055 331.823 211.6 332.785 212.146C335.784 203.941 341.568 191.832 341.402 184.206Z",
    fill: "#A0335D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M356.366 149.168C361.785 149.002 364.917 146.389 364.917 146.389C364.917 146.389 363.641 145.76 361.388 145.198C360.46 143.94 358.968 141.211 359.266 136.893C359.432 134.478 359.614 132.443 359.88 130.475L348.727 142.187C348.66 142.485 348.578 142.716 348.495 142.981C349.307 143.907 352.157 146.951 356.366 149.168Z",
    fill: "#AC6B53"
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M345.678 146.918C341.104 144.933 331.475 155.189 320.919 166.289C306.253 181.724 299.31 190.971 304.729 195.884C310.744 201.327 321.251 190.673 332.917 180.036C344.584 169.399 357.195 151.963 345.678 146.934V146.918Z",
    fill: "url(#paint28_linear_10512_1257)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M373.949 114.165C373.949 120.137 378.191 134.182 374.347 138.83C372.507 141.047 364.901 143.247 357.079 143.445C349.373 143.644 341.452 141.857 338.618 139.756C332.901 135.521 337.557 125.96 338.485 117.606C339.413 109.252 342.479 97.6553 358.272 99.3095C372.226 100.765 373.949 114.165 373.949 114.165Z",
    fill: "url(#paint29_linear_10512_1257)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M340.921 114.363C340.921 114.363 341.982 99.4253 357.792 99.2764C371.911 99.144 373.601 112.114 373.601 112.114C373.601 112.114 373.203 96.0175 356.98 96.1829C338.187 96.3483 337.69 113.42 337.69 113.42L340.921 114.347V114.363Z",
    fill: "#491D17"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M337.574 111.054C337.06 111.054 336.563 111.153 336.082 111.318C336.082 112.162 336.066 112.973 335.933 113.717L338.303 111.153C338.054 111.103 337.822 111.037 337.557 111.037L337.574 111.054Z",
    fill: "#491D17"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M337.574 132.328C341.336 132.328 344.368 127.563 344.368 121.691C344.368 116.943 342.363 112.956 339.612 111.6C339.049 113.634 338.701 115.702 338.485 117.621C337.955 122.419 336.198 127.613 335.884 131.964C336.43 132.179 336.994 132.344 337.574 132.344V132.328Z",
    fill: "#491D17"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M373.949 114.163C373.949 114.163 373.899 113.865 373.8 113.386C373.386 107.017 371.579 102.501 368.232 99.3574C371.132 104.155 371.099 110.54 361.255 111.715C344.02 113.766 337.508 104.866 337.806 100.35C334.84 104.486 336.596 109.812 335.95 113.733L340.557 108.754C339.364 111.665 338.8 114.808 338.502 117.604C337.574 125.958 332.917 135.503 338.634 139.755C341.468 141.856 349.39 143.642 357.096 143.444C364.917 143.245 372.524 141.028 374.363 138.828C378.208 134.18 373.966 120.135 373.966 114.163H373.949Z",
    fill: "#491D17"
  }))), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M340.076 113.238C340.076 113.238 341.17 98.3003 357.377 98.1514C371.861 98.019 373.584 110.989 373.584 110.989C373.584 110.989 373.17 94.8925 356.532 95.0579C337.259 95.2233 336.745 112.295 336.745 112.295L340.06 113.222L340.076 113.238Z",
    fill: "url(#paint30_linear_10512_1257)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M357.178 97.1419C341.518 97.2907 339.248 111.12 339.032 112.94L340.093 113.238C340.093 113.238 341.187 98.2998 357.394 98.151C371.878 98.0186 373.601 110.988 373.601 110.988C373.601 110.988 373.369 108.11 371.911 104.801C369.79 101.162 365.547 97.0591 357.178 97.1419Z",
    fill: "#463332"
  }))), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M336.961 130.74C340.375 130.74 343.142 126.334 343.142 120.898C343.142 115.462 340.375 111.055 336.961 111.055C333.547 111.055 330.779 115.462 330.779 120.898C330.779 126.334 333.547 130.74 336.961 130.74Z",
    fill: "url(#paint31_linear_10512_1257)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M339.927 120.948C339.927 125.365 337.673 128.955 334.906 128.955C332.138 128.955 329.885 125.365 329.885 120.948C329.885 116.531 332.138 112.941 334.906 112.941C337.673 112.941 339.927 116.531 339.927 120.948Z",
    fill: "url(#paint32_linear_10512_1257)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M336.961 111.055C336.812 111.055 336.696 111.104 336.546 111.121C339.43 111.733 341.651 115.637 341.651 120.385C341.651 125.579 339.016 129.781 335.751 129.781C334.956 129.781 334.193 129.516 333.497 129.053C334.492 130.112 335.668 130.74 336.961 130.74C340.375 130.74 343.142 126.34 343.142 120.898C343.142 115.455 340.375 111.055 336.961 111.055Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M334.906 112.941C333.978 112.941 333.116 113.372 332.354 114.083C332.818 113.818 333.298 113.636 333.829 113.636C336.165 113.636 338.071 116.664 338.071 120.402C338.071 124.141 336.165 127.168 333.829 127.168C332.337 127.168 331.028 125.927 330.266 124.058C331.028 126.953 332.818 128.971 334.906 128.971C337.69 128.971 339.927 125.382 339.927 120.965C339.927 116.548 337.673 112.958 334.906 112.958V112.941Z",
    fill: "#A69B9B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M334.011 114.974C336.348 115.371 333.564 119.524 332.321 119.342C330.382 119.061 331.973 114.627 334.011 114.974Z",
    fill: "#FFF7E6"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M331.591 119.986C333.05 119.754 332.503 121.922 331.807 122.004C330.73 122.137 330.448 120.168 331.591 119.986Z",
    fill: "#FFF7E6"
  }))), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M394.034 187.58C392.642 211.335 384.074 225 366.989 225C349.903 225 342.927 211.335 344.319 187.58C345.711 163.825 352.091 138.994 372.027 138.994C391.963 138.994 395.443 163.825 394.051 187.58H394.034Z",
    fill: "url(#paint33_linear_10512_1257)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M397.796 187.58C396.404 211.335 387.836 225 370.751 225C353.665 225 346.688 211.335 348.08 187.58C349.472 163.825 355.853 138.994 375.789 138.994C395.724 138.994 399.205 163.825 397.813 187.58H397.796Z",
    fill: "url(#paint34_linear_10512_1257)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M383.478 140.583C393.338 147.978 395.178 166.39 394.134 184.223C392.791 207.217 384.489 220.451 367.934 220.451C360.145 220.451 354.56 217.49 350.931 211.981C354.394 220.418 360.874 225 370.734 225C387.82 225 396.404 211.336 397.779 187.581C398.956 167.316 396.57 146.307 383.461 140.566L383.478 140.583Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M339.264 173.619C339.264 173.619 341.336 168.623 340.839 167.416C340.839 167.416 333.265 175.24 332.105 176.283C321.516 185.943 311.424 197.193 305.971 192.246C300.967 187.714 305.01 170.509 307.413 162.387C306.783 162.387 306.402 162.486 306.402 162.486C306.402 162.486 298.464 187.234 303.701 194.645C303.784 194.777 303.867 194.926 303.966 195.059C304.016 195.108 304.033 195.191 304.082 195.24H304.115C304.298 195.472 304.48 195.687 304.712 195.902C310.728 201.345 321.234 190.691 332.901 180.054C334.193 178.88 337.673 175.472 339.264 173.636V173.619Z",
    fill: "#A0335D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M313.793 173.336C313.661 169.713 313.412 166.951 313.412 166.951C310.595 161.31 306.386 162.484 306.386 162.484C306.386 162.484 298 188.572 304.082 195.239C300.552 188.324 310.479 177.555 313.661 174.147L313.777 173.353L313.793 173.336Z",
    fill: "#A0335D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M317.804 157.01C317.804 157.01 317.804 157.01 317.82 157.01C317.307 157.06 316.959 156.911 316.876 156.365C316.826 156.084 316.876 155.075 316.876 155.075V152.461C316.727 152.577 315.252 153.983 315.334 155.29C315.434 156.845 316.561 157.242 317.804 157.027V157.01Z",
    fill: "#C3694D"
  })))), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M168.79 196.779V186.87H167.033V184.008H248.003C249.412 184.008 250.555 185.149 250.555 186.555V197.11C250.555 198.516 249.412 199.657 248.003 199.657H167.033V196.795H168.79V196.779Z",
    fill: "url(#paint35_linear_10512_1257)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M248.003 184.007H211.015V199.64H248.003C249.412 199.64 250.555 198.498 250.555 197.092V186.538C250.555 185.132 249.412 183.99 248.003 183.99V184.007Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M246.744 196.777H170.944V186.868H246.744C247.639 186.868 248.351 187.596 248.351 188.473V195.156C248.351 196.049 247.622 196.761 246.744 196.761V196.777Z",
    fill: "#60578F"
  }))), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M244.589 196.777H168.79V186.868H244.589C245.484 186.868 246.197 187.596 246.197 188.473V195.156C246.197 196.049 245.468 196.761 244.589 196.761V196.777Z",
    fill: "#CEB6AA"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M209.324 186.869H168.79V196.778H209.324V186.869Z",
    fill: "#CEB6AA"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M209.324 186.869H168.79V196.778H209.324V186.869Z",
    fill: "#FFE6D6"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M207.949 186.869H244.573C245.468 186.869 246.18 187.597 246.18 188.474V190.757C246.18 189.863 245.451 189.152 244.573 189.152H207.949V186.869Z",
    fill: "#B29B93"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M243.462 191.169C243.462 191.169 242.402 191.252 240.794 191.334C239.187 191.417 237.049 191.45 234.911 191.467C232.774 191.45 230.636 191.417 229.028 191.334C227.421 191.252 226.36 191.169 226.36 191.169C226.36 191.169 227.437 191.086 229.028 191.003C230.636 190.921 232.774 190.888 234.911 190.871C237.049 190.888 239.187 190.921 240.794 191.003C242.402 191.086 243.462 191.169 243.462 191.169Z",
    fill: "#B29B93"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M207.303 192.989C207.303 192.989 205.297 193.055 202.298 193.138C199.298 193.204 195.305 193.237 191.311 193.254C187.317 193.237 183.307 193.204 180.324 193.138C177.324 193.055 175.319 192.989 175.319 192.989C175.319 192.989 177.324 192.923 180.324 192.84C183.323 192.774 187.317 192.741 191.311 192.725C195.305 192.741 199.315 192.774 202.298 192.84C205.297 192.923 207.303 192.989 207.303 192.989Z",
    fill: "#CEB6AA"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M184.202 190.657C184.202 190.657 183.34 190.74 182.064 190.806C180.788 190.872 179.064 190.905 177.357 190.922C175.65 190.905 173.944 190.872 172.651 190.806C171.375 190.74 170.513 190.657 170.513 190.657C170.513 190.657 171.375 190.575 172.651 190.508C173.927 190.442 175.65 190.409 177.357 190.393C179.064 190.409 180.771 190.442 182.064 190.508C183.34 190.575 184.202 190.657 184.202 190.657Z",
    fill: "#CEB6AA"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M209.324 186.869H168.79V189.119H209.324V186.869Z",
    fill: "#CEB6AA"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M237.364 175.586V169.449H238.756V167.199H175.004C173.894 167.199 172.999 168.093 172.999 169.201V175.851C172.999 176.959 173.894 177.853 175.004 177.853H238.756V175.603H237.364V175.586Z",
    fill: "url(#paint36_linear_10512_1257)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M175.999 169.448H235.674V175.586H175.999C175.302 175.586 174.722 175.023 174.722 174.312V170.705C174.722 170.011 175.286 169.432 175.999 169.432V169.448Z",
    fill: "#A0335D"
  }))), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M177.689 169.448H237.364V175.586H177.689C176.993 175.586 176.413 175.023 176.413 174.312V170.705C176.413 170.011 176.976 169.432 177.689 169.432V169.448Z",
    fill: "#FFE6D6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M238.756 169.449V167.199H206.226V177.853H238.756V175.603H237.364V169.466H238.756V169.449Z",
    fill: "#A0335D"
  }))), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M237.364 169.449H205.447V175.587H237.364V169.449Z",
    fill: "#CEB6AA"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M237.364 169.449H205.447V175.587H237.364V169.449Z",
    fill: "#CEB6AA"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M206.524 169.449H177.689C176.993 169.449 176.413 170.012 176.413 170.723V172.526C176.413 171.831 176.976 171.252 177.689 171.252H206.524V169.449Z",
    fill: "#CEB6AA"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M178.567 172.492L180.672 172.36C181.931 172.294 183.622 172.277 185.295 172.244C186.986 172.261 188.659 172.277 189.919 172.343C191.178 172.426 192.023 172.476 192.023 172.476C192.023 172.476 191.178 172.525 189.919 172.608C188.659 172.674 186.969 172.691 185.295 172.707C183.605 172.691 181.931 172.674 180.672 172.592C179.412 172.509 178.567 172.459 178.567 172.459V172.492Z",
    fill: "#CEB6AA"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M182.578 174.147C182.578 174.147 183.804 174.097 185.66 174.014C187.516 173.948 189.969 173.932 192.438 173.898C194.907 173.915 197.376 173.932 199.216 173.998C201.072 174.08 202.298 174.13 202.298 174.13C202.298 174.13 201.072 174.18 199.216 174.262C197.36 174.329 194.907 174.345 192.438 174.362C189.969 174.345 187.499 174.329 185.66 174.246C183.804 174.163 182.578 174.114 182.578 174.114V174.147Z",
    fill: "#CEB6AA"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M207.038 172.608C207.038 172.608 208.612 172.542 210.965 172.46C213.318 172.377 216.467 172.36 219.616 172.344C222.764 172.36 225.913 172.393 228.266 172.46C230.619 172.559 232.194 172.608 232.194 172.608C232.194 172.608 230.619 172.675 228.266 172.757C225.913 172.84 222.764 172.857 219.616 172.873C216.467 172.857 213.318 172.823 210.965 172.757C208.612 172.658 207.038 172.608 207.038 172.608Z",
    fill: "#B29B93"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M216.898 174.213C216.898 174.213 221.008 173.965 225.117 173.981C229.227 173.965 233.337 174.213 233.337 174.213C233.337 174.213 229.227 174.461 225.117 174.444C221.008 174.461 216.898 174.213 216.898 174.213Z",
    fill: "#B29B93"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M237.364 169.449H205.447V171.219H237.364V169.449Z",
    fill: "#B29B93"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M168.276 182.65V179.258H167V177.77H248.699C249.71 177.77 250.539 178.464 250.539 179.325V182.583C250.539 183.444 249.71 184.138 248.699 184.138H167V182.65H168.276Z",
    fill: "url(#paint37_linear_10512_1257)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M248.699 177.77H208.264V184.138H248.699C249.71 184.138 250.539 183.444 250.539 182.583V179.325C250.539 178.464 249.71 177.77 248.699 177.77Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M247.804 182.65H169.85V179.259H247.804C248.451 179.259 248.964 179.789 248.964 180.417V181.492C248.964 182.138 248.434 182.65 247.804 182.65Z",
    fill: "#AA2424"
  }))), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M246.246 182.65H168.293V179.259H246.246C246.893 179.259 247.407 179.789 247.407 180.417V181.492C247.407 182.138 246.876 182.65 246.246 182.65Z",
    fill: "#CEB6AA"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M208.993 179.258H168.276V182.649H208.993V179.258Z",
    fill: "#CEB6AA"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M208.993 179.258H168.276V182.649H208.993V179.258Z",
    fill: "#FFE6D6"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M207.999 179.258H246.247C246.893 179.258 247.407 179.787 247.407 180.416V182.07C247.407 181.425 246.876 180.912 246.247 180.912H207.999V179.258Z",
    fill: "#B29B93"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M208.993 179.258H168.276V180.879H208.993V179.258Z",
    fill: "#CEB6AA"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M30.468 74V57.284H24.756V54.4H39.792V57.284H34.052V74H30.468ZM46.2873 74.336C44.8873 74.336 43.646 74.0373 42.5633 73.44C41.4807 72.8427 40.6313 72.0027 40.0153 70.92C39.3993 69.8373 39.0913 68.5867 39.0913 67.168C39.0913 65.7307 39.39 64.452 39.9873 63.332C40.6033 62.212 41.4433 61.344 42.5073 60.728C43.59 60.0933 44.8593 59.776 46.3153 59.776C47.678 59.776 48.882 60.0747 49.9273 60.672C50.9727 61.2693 51.7847 62.0907 52.3633 63.136C52.9607 64.1627 53.2593 65.3107 53.2593 66.58C53.2593 66.7853 53.25 67 53.2313 67.224C53.2313 67.448 53.222 67.6813 53.2033 67.924H42.6473C42.722 69.0067 43.0953 69.856 43.7673 70.472C44.458 71.088 45.2887 71.396 46.2593 71.396C46.9873 71.396 47.594 71.2373 48.0793 70.92C48.5833 70.584 48.9567 70.1547 49.1993 69.632H52.8393C52.578 70.5093 52.1393 71.312 51.5233 72.04C50.926 72.7493 50.1793 73.3093 49.2833 73.72C48.406 74.1307 47.4073 74.336 46.2873 74.336ZM46.3153 62.688C45.438 62.688 44.6633 62.94 43.9913 63.444C43.3193 63.9293 42.89 64.676 42.7033 65.684H49.6193C49.5633 64.7693 49.2273 64.0413 48.6113 63.5C47.9953 62.9587 47.23 62.688 46.3153 62.688ZM60.7537 74.336C59.5591 74.336 58.5791 74.1493 57.8137 73.776C57.0484 73.384 56.4791 72.8707 56.1057 72.236C55.7324 71.6013 55.5457 70.9013 55.5457 70.136C55.5457 68.848 56.0497 67.8027 57.0577 67C58.0657 66.1973 59.5777 65.796 61.5937 65.796H65.1217V65.46C65.1217 64.508 64.8511 63.808 64.3097 63.36C63.7684 62.912 63.0964 62.688 62.2937 62.688C61.5657 62.688 60.9311 62.8653 60.3897 63.22C59.8484 63.556 59.5124 64.06 59.3817 64.732H55.8817C55.9751 63.724 56.3111 62.8467 56.8897 62.1C57.4871 61.3533 58.2524 60.784 59.1857 60.392C60.1191 59.9813 61.1644 59.776 62.3217 59.776C64.3004 59.776 65.8591 60.2707 66.9977 61.26C68.1364 62.2493 68.7057 63.6493 68.7057 65.46V74H65.6537L65.3177 71.76C64.9071 72.5067 64.3284 73.1227 63.5817 73.608C62.8537 74.0933 61.9111 74.336 60.7537 74.336ZM61.5657 71.536C62.5924 71.536 63.3857 71.2 63.9457 70.528C64.5244 69.856 64.8884 69.0253 65.0377 68.036H61.9857C61.0337 68.036 60.3524 68.2133 59.9417 68.568C59.5311 68.904 59.3257 69.324 59.3257 69.828C59.3257 70.3693 59.5311 70.7893 59.9417 71.088C60.3524 71.3867 60.8937 71.536 61.5657 71.536ZM78.6219 74.336C77.2032 74.336 75.9525 74.028 74.8699 73.412C73.7872 72.796 72.9285 71.9373 72.2939 70.836C71.6779 69.7347 71.3699 68.4747 71.3699 67.056C71.3699 65.6373 71.6779 64.3773 72.2939 63.276C72.9285 62.1747 73.7872 61.316 74.8699 60.7C75.9525 60.084 77.2032 59.776 78.6219 59.776C80.3952 59.776 81.8885 60.2427 83.1019 61.176C84.3152 62.0907 85.0899 63.36 85.4259 64.984H81.6459C81.4592 64.312 81.0859 63.7893 80.5259 63.416C79.9845 63.024 79.3405 62.828 78.5939 62.828C77.6045 62.828 76.7645 63.2013 76.0739 63.948C75.3832 64.6947 75.0379 65.7307 75.0379 67.056C75.0379 68.3813 75.3832 69.4173 76.0739 70.164C76.7645 70.9107 77.6045 71.284 78.5939 71.284C79.3405 71.284 79.9845 71.0973 80.5259 70.724C81.0859 70.3507 81.4592 69.8187 81.6459 69.128H85.4259C85.0899 70.696 84.3152 71.956 83.1019 72.908C81.8885 73.86 80.3952 74.336 78.6219 74.336ZM88.2989 74V53.84H91.8829V62.24C92.3496 61.4747 92.9749 60.8773 93.7589 60.448C94.5616 60 95.4763 59.776 96.5029 59.776C98.2203 59.776 99.5456 60.3173 100.479 61.4C101.431 62.4827 101.907 64.0693 101.907 66.16V74H98.3509V66.496C98.3509 65.3013 98.1083 64.3867 97.6229 63.752C97.1563 63.1173 96.4096 62.8 95.3829 62.8C94.3749 62.8 93.5349 63.1547 92.8629 63.864C92.2096 64.5733 91.8829 65.5627 91.8829 66.832V74H88.2989ZM111.774 74.336C110.374 74.336 109.133 74.0373 108.05 73.44C106.967 72.8427 106.118 72.0027 105.502 70.92C104.886 69.8373 104.578 68.5867 104.578 67.168C104.578 65.7307 104.877 64.452 105.474 63.332C106.09 62.212 106.93 61.344 107.994 60.728C109.077 60.0933 110.346 59.776 111.802 59.776C113.165 59.776 114.369 60.0747 115.414 60.672C116.459 61.2693 117.271 62.0907 117.85 63.136C118.447 64.1627 118.746 65.3107 118.746 66.58C118.746 66.7853 118.737 67 118.718 67.224C118.718 67.448 118.709 67.6813 118.69 67.924H108.134C108.209 69.0067 108.582 69.856 109.254 70.472C109.945 71.088 110.775 71.396 111.746 71.396C112.474 71.396 113.081 71.2373 113.566 70.92C114.07 70.584 114.443 70.1547 114.686 69.632H118.326C118.065 70.5093 117.626 71.312 117.01 72.04C116.413 72.7493 115.666 73.3093 114.77 73.72C113.893 74.1307 112.894 74.336 111.774 74.336ZM111.802 62.688C110.925 62.688 110.15 62.94 109.478 63.444C108.806 63.9293 108.377 64.676 108.19 65.684H115.106C115.05 64.7693 114.714 64.0413 114.098 63.5C113.482 62.9587 112.717 62.688 111.802 62.688ZM121.452 74V60.112H124.644L124.98 62.716C125.484 61.82 126.166 61.1107 127.024 60.588C127.902 60.0467 128.928 59.776 130.104 59.776V63.556H129.096C128.312 63.556 127.612 63.6773 126.996 63.92C126.38 64.1627 125.895 64.5827 125.54 65.18C125.204 65.7773 125.036 66.608 125.036 67.672V74H121.452ZM34.78 104.336C32.8013 104.336 31.1027 103.916 29.684 103.076C28.2653 102.217 27.1733 101.032 26.408 99.52C25.6427 97.9893 25.26 96.2253 25.26 94.228C25.26 92.2307 25.6427 90.4667 26.408 88.936C27.1733 87.4053 28.2653 86.2107 29.684 85.352C31.1027 84.4933 32.8013 84.064 34.78 84.064C37.132 84.064 39.0547 84.652 40.548 85.828C42.06 86.9853 43.0027 88.6187 43.376 90.728H39.428C39.1853 89.664 38.6627 88.8333 37.86 88.236C37.076 87.62 36.0307 87.312 34.724 87.312C32.9133 87.312 31.4947 87.928 30.468 89.16C29.4413 90.392 28.928 92.0813 28.928 94.228C28.928 96.3747 29.4413 98.064 30.468 99.296C31.4947 100.509 32.9133 101.116 34.724 101.116C36.0307 101.116 37.076 100.836 37.86 100.276C38.6627 99.6973 39.1853 98.904 39.428 97.896H43.376C43.0027 99.912 42.06 101.489 40.548 102.628C39.0547 103.767 37.132 104.336 34.78 104.336ZM50.9445 104.336C49.7499 104.336 48.7699 104.149 48.0045 103.776C47.2392 103.384 46.6699 102.871 46.2965 102.236C45.9232 101.601 45.7365 100.901 45.7365 100.136C45.7365 98.848 46.2405 97.8027 47.2485 97C48.2565 96.1973 49.7685 95.796 51.7845 95.796H55.3125V95.46C55.3125 94.508 55.0419 93.808 54.5005 93.36C53.9592 92.912 53.2872 92.688 52.4845 92.688C51.7565 92.688 51.1219 92.8653 50.5805 93.22C50.0392 93.556 49.7032 94.06 49.5725 94.732H46.0725C46.1659 93.724 46.5019 92.8467 47.0805 92.1C47.6779 91.3533 48.4432 90.784 49.3765 90.392C50.3099 89.9813 51.3552 89.776 52.5125 89.776C54.4912 89.776 56.0499 90.2707 57.1885 91.26C58.3272 92.2493 58.8965 93.6493 58.8965 95.46V104H55.8445L55.5085 101.76C55.0979 102.507 54.5192 103.123 53.7725 103.608C53.0445 104.093 52.1019 104.336 50.9445 104.336ZM51.7565 101.536C52.7832 101.536 53.5765 101.2 54.1365 100.528C54.7152 99.856 55.0792 99.0253 55.2285 98.036H52.1765C51.2245 98.036 50.5432 98.2133 50.1325 98.568C49.7219 98.904 49.5165 99.324 49.5165 99.828C49.5165 100.369 49.7219 100.789 50.1325 101.088C50.5432 101.387 51.0845 101.536 51.7565 101.536ZM62.0087 110.16V90.112H65.2007L65.5927 92.1C66.0407 91.484 66.6287 90.9427 67.3567 90.476C68.1034 90.0093 69.0647 89.776 70.2407 89.776C71.5474 89.776 72.714 90.0933 73.7407 90.728C74.7674 91.3627 75.5794 92.2307 76.1767 93.332C76.774 94.4333 77.0727 95.684 77.0727 97.084C77.0727 98.484 76.774 99.7347 76.1767 100.836C75.5794 101.919 74.7674 102.777 73.7407 103.412C72.714 104.028 71.5474 104.336 70.2407 104.336C69.1954 104.336 68.2807 104.14 67.4967 103.748C66.7127 103.356 66.078 102.805 65.5927 102.096V110.16H62.0087ZM69.4847 101.2C70.6234 101.2 71.566 100.817 72.3127 100.052C73.0594 99.2867 73.4327 98.2973 73.4327 97.084C73.4327 95.8707 73.0594 94.872 72.3127 94.088C71.566 93.304 70.6234 92.912 69.4847 92.912C68.3274 92.912 67.3754 93.304 66.6287 94.088C65.9007 94.8533 65.5367 95.8427 65.5367 97.056C65.5367 98.2693 65.9007 99.268 66.6287 100.052C67.3754 100.817 68.3274 101.2 69.4847 101.2ZM84.7543 104.336C83.5596 104.336 82.5796 104.149 81.8143 103.776C81.049 103.384 80.4796 102.871 80.1063 102.236C79.733 101.601 79.5463 100.901 79.5463 100.136C79.5463 98.848 80.0503 97.8027 81.0583 97C82.0663 96.1973 83.5783 95.796 85.5943 95.796H89.1223V95.46C89.1223 94.508 88.8516 93.808 88.3103 93.36C87.769 92.912 87.097 92.688 86.2943 92.688C85.5663 92.688 84.9316 92.8653 84.3903 93.22C83.849 93.556 83.513 94.06 83.3823 94.732H79.8823C79.9756 93.724 80.3116 92.8467 80.8903 92.1C81.4876 91.3533 82.253 90.784 83.1863 90.392C84.1196 89.9813 85.165 89.776 86.3223 89.776C88.301 89.776 89.8596 90.2707 90.9983 91.26C92.137 92.2493 92.7063 93.6493 92.7063 95.46V104H89.6543L89.3183 101.76C88.9076 102.507 88.329 103.123 87.5823 103.608C86.8543 104.093 85.9116 104.336 84.7543 104.336ZM85.5663 101.536C86.593 101.536 87.3863 101.2 87.9463 100.528C88.525 99.856 88.889 99.0253 89.0383 98.036H85.9863C85.0343 98.036 84.353 98.2133 83.9423 98.568C83.5316 98.904 83.3263 99.324 83.3263 99.828C83.3263 100.369 83.5316 100.789 83.9423 101.088C84.353 101.387 84.8943 101.536 85.5663 101.536ZM104.05 104.336C103.005 104.336 102.09 104.14 101.306 103.748C100.522 103.356 99.8878 102.805 99.4025 102.096L99.0105 104H95.8185V83.84H99.4025V92.1C99.8505 91.484 100.438 90.9427 101.166 90.476C101.913 90.0093 102.874 89.776 104.05 89.776C105.357 89.776 106.524 90.0933 107.55 90.728C108.577 91.3627 109.389 92.2307 109.986 93.332C110.584 94.4333 110.882 95.684 110.882 97.084C110.882 98.484 110.584 99.7347 109.986 100.836C109.389 101.919 108.577 102.777 107.55 103.412C106.524 104.028 105.357 104.336 104.05 104.336ZM103.294 101.2C104.433 101.2 105.376 100.817 106.122 100.052C106.869 99.2867 107.242 98.2973 107.242 97.084C107.242 95.8707 106.869 94.872 106.122 94.088C105.376 93.304 104.433 92.912 103.294 92.912C102.137 92.912 101.185 93.304 100.438 94.088C99.7105 94.8533 99.3465 95.8427 99.3465 97.056C99.3465 98.2693 99.7105 99.268 100.438 100.052C101.185 100.817 102.137 101.2 103.294 101.2ZM115.708 87.956C115.055 87.956 114.513 87.76 114.084 87.368C113.673 86.976 113.468 86.4813 113.468 85.884C113.468 85.2867 113.673 84.8013 114.084 84.428C114.513 84.036 115.055 83.84 115.708 83.84C116.361 83.84 116.893 84.036 117.304 84.428C117.733 84.8013 117.948 85.2867 117.948 85.884C117.948 86.4813 117.733 86.976 117.304 87.368C116.893 87.76 116.361 87.956 115.708 87.956ZM113.916 104V90.112H117.5V104H113.916ZM120.933 104V83.84H124.517V104H120.933ZM129.803 87.956C129.15 87.956 128.608 87.76 128.179 87.368C127.768 86.976 127.563 86.4813 127.563 85.884C127.563 85.2867 127.768 84.8013 128.179 84.428C128.608 84.036 129.15 83.84 129.803 83.84C130.456 83.84 130.988 84.036 131.399 84.428C131.828 84.8013 132.043 85.2867 132.043 85.884C132.043 86.4813 131.828 86.976 131.399 87.368C130.988 87.76 130.456 87.956 129.803 87.956ZM128.011 104V90.112H131.595V104H128.011ZM141.216 104C139.76 104 138.593 103.645 137.716 102.936C136.839 102.227 136.4 100.967 136.4 99.156V93.108H134.02V90.112H136.4L136.82 86.388H139.984V90.112H143.736V93.108H139.984V99.184C139.984 99.856 140.124 100.323 140.404 100.584C140.703 100.827 141.207 100.948 141.916 100.948H143.652V104H141.216ZM148.241 110.16L151.461 103.076H150.621L145.217 90.112H149.109L153.001 99.884L157.061 90.112H160.869L152.049 110.16H148.241ZM32.596 134.336C31.1587 134.336 29.8893 134.093 28.788 133.608C27.6867 133.104 26.8187 132.395 26.184 131.48C25.5493 130.547 25.2227 129.417 25.204 128.092H28.984C29.0213 129.007 29.348 129.781 29.964 130.416C30.5987 131.032 31.4667 131.34 32.568 131.34C33.52 131.34 34.276 131.116 34.836 130.668C35.396 130.201 35.676 129.585 35.676 128.82C35.676 128.017 35.424 127.392 34.92 126.944C34.4347 126.496 33.7813 126.132 32.96 125.852C32.1387 125.572 31.2613 125.273 30.328 124.956C28.816 124.433 27.6587 123.761 26.856 122.94C26.072 122.119 25.68 121.027 25.68 119.664C25.6613 118.507 25.932 117.517 26.492 116.696C27.0707 115.856 27.8547 115.212 28.844 114.764C29.8333 114.297 30.972 114.064 32.26 114.064C33.5667 114.064 34.7147 114.297 35.704 114.764C36.712 115.231 37.496 115.884 38.056 116.724C38.6347 117.564 38.9427 118.563 38.98 119.72H35.144C35.1253 119.029 34.8547 118.423 34.332 117.9C33.828 117.359 33.1187 117.088 32.204 117.088C31.42 117.069 30.7573 117.265 30.216 117.676C29.6933 118.068 29.432 118.647 29.432 119.412C29.432 120.065 29.6373 120.588 30.048 120.98C30.4587 121.353 31.0187 121.671 31.728 121.932C32.4373 122.193 33.2493 122.473 34.164 122.772C35.1347 123.108 36.0213 123.5 36.824 123.948C37.6267 124.396 38.2707 124.993 38.756 125.74C39.2413 126.468 39.484 127.411 39.484 128.568C39.484 129.595 39.2227 130.547 38.7 131.424C38.1773 132.301 37.4027 133.011 36.376 133.552C35.3493 134.075 34.0893 134.336 32.596 134.336ZM43.955 140.16L47.175 133.076H46.335L40.931 120.112H44.823L48.715 129.884L52.775 120.112H56.583L47.763 140.16H43.955ZM63.6745 134.336C62.4425 134.336 61.3598 134.14 60.4265 133.748C59.4931 133.337 58.7465 132.777 58.1865 132.068C57.6265 131.359 57.2905 130.537 57.1785 129.604H60.7905C60.9025 130.145 61.2011 130.612 61.6865 131.004C62.1905 131.377 62.8345 131.564 63.6185 131.564C64.4025 131.564 64.9718 131.405 65.3265 131.088C65.6998 130.771 65.8865 130.407 65.8865 129.996C65.8865 129.399 65.6251 128.997 65.1025 128.792C64.5798 128.568 63.8518 128.353 62.9185 128.148C62.3211 128.017 61.7145 127.859 61.0985 127.672C60.4825 127.485 59.9131 127.252 59.3905 126.972C58.8865 126.673 58.4758 126.3 58.1585 125.852C57.8411 125.385 57.6825 124.816 57.6825 124.144C57.6825 122.912 58.1678 121.876 59.1385 121.036C60.1278 120.196 61.5091 119.776 63.2825 119.776C64.9251 119.776 66.2318 120.159 67.2025 120.924C68.1918 121.689 68.7798 122.744 68.9665 124.088H65.5785C65.3731 123.061 64.5985 122.548 63.2545 122.548C62.5825 122.548 62.0598 122.679 61.6865 122.94C61.3318 123.201 61.1545 123.528 61.1545 123.92C61.1545 124.331 61.4251 124.657 61.9665 124.9C62.5078 125.143 63.2265 125.367 64.1225 125.572C65.0931 125.796 65.9798 126.048 66.7825 126.328C67.6038 126.589 68.2571 126.991 68.7425 127.532C69.2278 128.055 69.4705 128.811 69.4705 129.8C69.4891 130.659 69.2651 131.433 68.7985 132.124C68.3318 132.815 67.6598 133.356 66.7825 133.748C65.9051 134.14 64.8691 134.336 63.6745 134.336ZM78.0879 134C76.6319 134 75.4652 133.645 74.5879 132.936C73.7106 132.227 73.2719 130.967 73.2719 129.156V123.108H70.8919V120.112H73.2719L73.6919 116.388H76.8559V120.112H80.6079V123.108H76.8559V129.184C76.8559 129.856 76.9959 130.323 77.2759 130.584C77.5746 130.827 78.0786 130.948 78.7879 130.948H80.5239V134H78.0879ZM89.7696 134.336C88.3696 134.336 87.1283 134.037 86.0456 133.44C84.9629 132.843 84.1136 132.003 83.4976 130.92C82.8816 129.837 82.5736 128.587 82.5736 127.168C82.5736 125.731 82.8723 124.452 83.4696 123.332C84.0856 122.212 84.9256 121.344 85.9896 120.728C87.0723 120.093 88.3416 119.776 89.7976 119.776C91.1603 119.776 92.3643 120.075 93.4096 120.672C94.4549 121.269 95.2669 122.091 95.8456 123.136C96.4429 124.163 96.7416 125.311 96.7416 126.58C96.7416 126.785 96.7323 127 96.7136 127.224C96.7136 127.448 96.7043 127.681 96.6856 127.924H86.1296C86.2043 129.007 86.5776 129.856 87.2496 130.472C87.9403 131.088 88.7709 131.396 89.7416 131.396C90.4696 131.396 91.0763 131.237 91.5616 130.92C92.0656 130.584 92.4389 130.155 92.6816 129.632H96.3216C96.0603 130.509 95.6216 131.312 95.0056 132.04C94.4083 132.749 93.6616 133.309 92.7656 133.72C91.8883 134.131 90.8896 134.336 89.7696 134.336ZM89.7976 122.688C88.9203 122.688 88.1456 122.94 87.4736 123.444C86.8016 123.929 86.3723 124.676 86.1856 125.684H93.1016C93.0456 124.769 92.7096 124.041 92.0936 123.5C91.4776 122.959 90.7123 122.688 89.7976 122.688ZM99.448 134V120.112H102.612L102.92 121.988C103.368 121.316 103.956 120.784 104.684 120.392C105.431 119.981 106.289 119.776 107.26 119.776C109.407 119.776 110.928 120.607 111.824 122.268C112.328 121.503 113 120.896 113.84 120.448C114.699 120 115.632 119.776 116.64 119.776C118.451 119.776 119.841 120.317 120.812 121.4C121.783 122.483 122.268 124.069 122.268 126.16V134H118.684V126.496C118.684 125.301 118.451 124.387 117.984 123.752C117.536 123.117 116.836 122.8 115.884 122.8C114.913 122.8 114.129 123.155 113.532 123.864C112.953 124.573 112.664 125.563 112.664 126.832V134H109.08V126.496C109.08 125.301 108.847 124.387 108.38 123.752C107.913 123.117 107.195 122.8 106.224 122.8C105.272 122.8 104.497 123.155 103.9 123.864C103.321 124.573 103.032 125.563 103.032 126.832V134H99.448Z",
    fill: "#FFB900"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10512_1257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9481 20.8595H44.2965V27.1487H48.4062V29.561H41.9481V20.8595ZM49.7062 20.8595H56.4997V22.9272H52.0126V24.2626H56.0804V26.1579H52.0126V27.5364H56.5417V29.6041H49.7062V20.8595ZM60.9868 20.8164H63.2513L66.8578 29.561H64.3417L63.7126 28.0103H60.4417L59.8546 29.561H57.3804L60.9868 20.8164ZM63.0417 26.1149L62.1191 23.6595L61.1546 26.1149H63.0417ZM67.9901 20.8595H71.261C74.2804 20.8595 76.0417 22.6256 76.0417 25.1672C76.0417 27.6656 74.2804 29.5179 71.2191 29.5179H67.9901V20.8595ZM71.261 27.4072C72.6449 27.4072 73.6094 26.6318 73.6094 25.2103V25.1672C73.6094 23.7887 72.6868 22.9703 71.261 22.9703H70.2965V27.4072H71.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0935 41.28L47.3161 40.5477L45.429 34.6031L49.329 33.3108L48.6161 31.0277L42.4935 33.0523L45.0935 41.28ZM30.5419 26.3323L31.2548 24.0492L37.0419 25.9877L38.929 20L41.1516 20.7323L38.5516 29.0031L30.5419 26.3323ZM44.3806 41.6677L42.4935 43.0892L38.8871 38.0062L30.3323 43.52L24 48L30.4581 38.0062L33.6871 32.6646L28.7387 28.96L30.1226 27.0215L37 32.1477L30.8774 40.9354L39.4323 34.6462L44.3806 41.6677Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10512_1257)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 147,
    width: 48,
    height: 28,
    rx: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 147,
    width: 48,
    height: 28,
    rx: 14,
    fill: "url(#paint38_linear_10512_1257)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 147,
    width: 48,
    height: 28,
    rx: 14,
    fill: "url(#paint39_linear_10512_1257)"
  }))), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6979 165.899C49.3941 165.595 49.3941 165.105 49.6979 164.802L52.7124 161.776H40.8958C40.4674 161.776 40.1168 161.426 40.1168 160.999C40.1168 160.571 40.4674 160.221 40.8958 160.221H52.7124L49.6901 157.203C49.3863 156.9 49.3863 156.41 49.6901 156.106C49.9939 155.803 50.4846 155.803 50.7884 156.106L55.1505 160.454C55.4543 160.758 55.4543 161.248 55.1505 161.551L50.7962 165.899C50.4924 166.194 49.9939 166.194 49.6979 165.899Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10512_1257",
    x: 16,
    y: 139,
    width: 64,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10512_1257"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10512_1257",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10512_1257",
    x1: 267.061,
    y1: 66.207,
    x2: 267.061,
    y2: 173.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10512_1257",
    x1: 267.061,
    y1: 158.896,
    x2: 267.061,
    y2: 190.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10512_1257",
    x1: 267.061,
    y1: 68.375,
    x2: 267.061,
    y2: 156.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#71C6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4AA1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10512_1257",
    x1: 267.061,
    y1: 194.395,
    x2: 267.061,
    y2: 168.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10512_1257",
    x1: 328.625,
    y1: 170.493,
    x2: 328.625,
    y2: 163.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10512_1257",
    x1: 301.819,
    y1: 74.2833,
    x2: 301.819,
    y2: 85.5654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10512_1257",
    x1: 281,
    y1: 83.3305,
    x2: 281,
    y2: 97.8541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10512_1257",
    x1: 281.024,
    y1: 96.1429,
    x2: 281.024,
    y2: 110.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10512_1257",
    x1: 281,
    y1: 109.338,
    x2: 281,
    y2: 123.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10512_1257",
    x1: 281,
    y1: 122.338,
    x2: 281,
    y2: 136.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#566AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4953AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10512_1257",
    x1: 236.818,
    y1: 74.6778,
    x2: 236.818,
    y2: 85.9599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10512_1257",
    x1: 216,
    y1: 83.3305,
    x2: 216,
    y2: 97.8541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10512_1257",
    x1: 216.024,
    y1: 96.1429,
    x2: 216.024,
    y2: 110.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10512_1257",
    x1: 216,
    y1: 109.338,
    x2: 216,
    y2: 123.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10512_1257",
    x1: 296.06,
    y1: 177.667,
    x2: 296.129,
    y2: 201.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#71C6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4AA1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10512_1257",
    x1: 286.355,
    y1: 177.611,
    x2: 286.424,
    y2: 200.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#71C6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4AA1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10512_1257",
    x1: 287.643,
    y1: 149.946,
    x2: 287.643,
    y2: 185.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D8C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10512_1257",
    x1: 371.927,
    y1: 111.533,
    x2: 371.927,
    y2: 129.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10512_1257",
    x1: 369.922,
    y1: 109.367,
    x2: 369.922,
    y2: 131.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10512_1257",
    x1: 334.044,
    y1: 133.768,
    x2: 334.044,
    y2: 184.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10512_1257",
    x1: 317.066,
    y1: 162.798,
    x2: 306.648,
    y2: 148.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10512_1257",
    x1: 285.77,
    y1: 145.129,
    x2: 285.535,
    y2: 224.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10512_1257",
    x1: 377.794,
    y1: 145.083,
    x2: 377.794,
    y2: 223.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10512_1257",
    x1: 341.419,
    y1: 92.1129,
    x2: 341.419,
    y2: 160.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#864235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5A271F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491D17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_10512_1257",
    x1: 354.345,
    y1: 149.417,
    x2: 354.345,
    y2: 136.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_10512_1257",
    x1: 358.405,
    y1: 92.1125,
    x2: 358.405,
    y2: 160.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#864235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5A271F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491D17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_10512_1257",
    x1: 354.444,
    y1: 145.083,
    x2: 354.444,
    y2: 223.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_10512_1257",
    x1: 355.157,
    y1: 150.524,
    x2: 355.157,
    y2: 131.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_10512_1257",
    x1: 326.554,
    y1: 145.082,
    x2: 326.554,
    y2: 223.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_10512_1257",
    x1: 355.902,
    y1: 92.1135,
    x2: 355.902,
    y2: 160.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#864235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5A271F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491D17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_10512_1257",
    x1: 355.173,
    y1: 93.4533,
    x2: 355.173,
    y2: 114.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_10512_1257",
    x1: 336.961,
    y1: 109.318,
    x2: 336.961,
    y2: 131.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_10512_1257",
    x1: 334.906,
    y1: 111.535,
    x2: 334.906,
    y2: 129.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_10512_1257",
    x1: 376.866,
    y1: 224.288,
    x2: 376.866,
    y2: 140.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_10512_1257",
    x1: 380.628,
    y1: 224.288,
    x2: 380.628,
    y2: 140.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#322424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3C2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#403131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_10512_1257",
    x1: 208.794,
    y1: 183.727,
    x2: 208.794,
    y2: 199.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_10512_1257",
    x1: 205.878,
    y1: 166.984,
    x2: 205.878,
    y2: 177.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_10512_1257",
    x1: 208.761,
    y1: 177.654,
    x2: 208.761,
    y2: 184.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_10512_1257",
    x1: 72,
    y1: 175,
    x2: 21.5788,
    y2: 169.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_10512_1257",
    x1: 48,
    y1: 107.042,
    x2: 48,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDA44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10512_1257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 382,
    height: 194,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10512_1257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 28,
    fill: "white",
    transform: "translate(24 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTas);
export default __webpack_public_path__ + "static/media/TAS.782b1e221b4f9d5ece6d9391f67778f4.svg";
export { ForwardRef as ReactComponent };